import { render } from "./FloatingButton.vue?vue&type=template&id=4b058d40"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"

import "./FloatingButton.vue?vue&type=style&index=0&id=4b058d40&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__